import { DateTime } from 'luxon'

import { FirebaseTime } from '../firebase/Firestore'

export const dateToString = (time: FirebaseTime, format: string = 'yyyy-MM-dd hh:mm'): string => {
  return DateTime.fromJSDate(time.toDate()).toFormat(format)
}
